import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import AlbumList from './album-list';
import NewAlbumButton from './new-album-button';

@inject('albumsStore', 'songsStore')
@observer
class Albums extends Component {
	render () {
		const { albumsStore, songsStore } = this.props;

		if (albumsStore.isLoading || songsStore.isLoading) {

			return (
				<h1>Albums Loading...</h1>
			);
		}

		return (
			<div>
				<div className="grid-x align-bottom">
					<div className="cell small-12">
						<NewAlbumButton />
					</div>
				</div>

				<div className="grid-x">
					<div className="cell small-12">
					</div>
					<div className="cell">
						<AlbumList />
					</div>
				</div>
			</div>
		);
	}
}

export default Albums;
